export const ANALYTICS_SEGMENT = 'segment';
export const ANALYTICS_SESSION_ID_STORAGE_KEY = 'analyticsSessionId';
export const ANALYTICS_ACTIONS = {
  DISPLAY: 'display'
};
export const ANALYTICS_EVENTS = {
  WEBVIEW_DISPLAYED: 'webview_displayed'
};
export const ANALYTICS_SOURCE_TYPES = {
  LIBRE_APP: 'libreApp',
  EXTERNAL_PARTNER: 'externalPartner'
};
export const ANALYTICS_MODULE_TYPES = {
  CONAPPS_MODULE: 'connectedApps'
};